export enum ProgrammingLanguageEnum {
  PYTHON = "python",
  R = "r",
  OTHER = "other",
}
